/** Sia platform agent — teal green primary (other agents use `--app-primary`). */
import { hashSeed } from './hashSeed.js'
import { hsl } from './hsl.js'

export const SIA_AGENT_PRIMARY = '#0d9488'

/** @param {string} seed */

/**
 * @param {number} hue
 * @param {number} sat
 * @param {number} light
 */

/**
 * @param {string} [agentId]
 * @param {string} [name]
 * @param {string} [seed]
 */

export function isSiaAgent(agentId, name, seed) {
  const id = String(agentId ?? '').trim().toLowerCase()
  if (id === 'agent-sia') return true
  const n = String(name ?? '').trim().toLowerCase()
  if (n === 'sia') return true
  const s = String(seed ?? '').trim().toLowerCase()
  return s === 'agent-sia' || s === 'sia' || s.startsWith('sia:')
}

/**
 * @param {string} [agentId]
 * @param {string} [name]
 * @param {string} [seed]
 */

export function getAgentAvatarPrimary(agentId, name, seed) {
  return isSiaAgent(agentId, name, seed) ? SIA_AGENT_PRIMARY : null
}

/**
 * Per-agent accent pair; dominant fill is `--agent-wave-primary` in CSS (~70%).
 *
 * @param {string} [seed]
 * @param {string} [agentId]
 * @param {string} [name]
 */
